import React, { useState, useEffect } from "react";
import { Card, Button, Table, Modal, Row, Col } from "react-bootstrap";
import {
  BrowserRouter as Router,
  useParams,
  useNavigate,
} from "react-router-dom";
import axios from "axios";
import GoBack from "../General/GoBack";
import ModalCargaMasiva from "./ModalCargaMasiva";
import API_URL from "../../localhost/config"; //Importa la variable global
import Sidebar from "../Sidebar/Sidebar";

const Torneo = () => {
  const { idTorneo } = useParams();
  const navigate = useNavigate();
  const [fechas, setFechas] = useState([]);
  const [nombreTorneo, setNombreNombre] = useState([]);

  // Eliminación equipo
  const [showModalConfirmation, setShowModalConfirmation] = useState(false);
  const [showModalCargaMasiva, setshowModalCargaMasiva] = useState(false);
  const [fechaAEliminar, setFechaAEliminar] = useState(null);

  const [error, setError] = useState("");
  const [triggerReloadFechas, setTriggerReloadFechas] = useState(false);

  //Token
  const [token, setToken] = useState(localStorage.getItem("token"));

  //Loading
  const [isLoading, setIsLoading] = useState(true); // Estado para controlar si los datos están cargados

  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const mostrarShowModalCargaMasiva = () => setshowModalCargaMasiva(true);
  const quitarShowModalCargaMasiva = () => {
    setshowModalCargaMasiva(false);
  };

  const handleCrearTurnosClick = () => {
    navigate(`/torneo/${idTorneo}/crear-turnos`);
  };

  const handleAsignarTurnosClick = () => {
    navigate(`/torneo/${idTorneo}/asignar-turnos`);
  };

  const handleNuevaFecha = () => {
    navigate(`/torneo/${idTorneo}/nueva-fecha`);
  };

  // Fetch de las fechas del torneo
  useEffect(() => {
    const obtenerFechas = async () => {
      try {
        setIsLoading(true);
        const response = await axios.get(
          `${API_URL}/getFechas?idTorneo=${idTorneo}`,
          headers
        );
        setFechas(response.data);
      } catch (error) {
        console.error(
          "Error al obtener la lista de fechas:",
          error.response?.data?.message || error.message
        );
        setError("Error al obtener la lista de fechas. Inténtalo de nuevo.");
      } finally {
        setIsLoading(false); // Marcar como no cargando, independientemente del resultado
      }
    };
    obtenerFechas();
  }, [idTorneo, triggerReloadFechas, token]);

  const handleEditMatchweek = () => {};

  const handleDeleteMatchweek = async (idFecha) => {
    setShowModalConfirmation(true);
    setFechaAEliminar(idFecha);
  };

  const confirmarEliminacion = async (idFecha) => {
    setShowModalConfirmation(false);
    try {
      // Realizar la solicitud DELETE a la API para eliminar la fecha
      await axios.delete(`${API_URL}/deleteMatchweek/${idFecha}`, headers);
      // Actualizar la lista de fechas después de eliminar la fecha
      const nuevasFechas = fechas.filter((fecha) => fecha.id !== idFecha);
      setFechas(nuevasFechas);
      // Puedes manejar el éxito de la eliminación aquí
    } catch (error) {
      // Manejar errores de manera más explícita, por ejemplo:
      console.error(
        "Error al eliminar la fecha:",
        error.response?.data?.message || error.message
      );
      // Puedes utilizar setError para manejar el error en tu aplicación
      setError("Error al eliminar la fecha. Inténtalo de nuevo.");
    }
    setTriggerReloadFechas(Date.now());
  };

  useEffect(() => {
    fetch(`${API_URL}/getTournamentById?idTorneo=${idTorneo}`, headers)
      .then((response) => response.json())
      .then((torneo) => {
        setNombreNombre(torneo[0].nombre);
      });
  }, [idTorneo]);

  return (
    <div className="row p-0 g-0">
      <div className="col-sm-auto p-0 g-0 flex-column">
        <Sidebar> </Sidebar>
      </div>

      {isLoading ? (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      ) : (
        <div className="col-sm p-0 g-0">
          <div className="section-title mt-5">
            <h3>
              Torneo <span>{nombreTorneo}</span>
            </h3>
            <p>Gestiona las acciones relacionadas con tu torneo</p>
          </div>

          <div className="row justify-content-center p-0 g-0">
            <div className="row">
              <div className="col-md-6 px-3">
                <div
                  className="card"
                  style={{ cursor: "pointer" }}
                  onClick={handleCrearTurnosClick}
                >
                  <div className="card-body section-typography">
                    <h6 className="">
                      Administrar <span>turnos</span>
                    </h6>
                    <p className="card-text mt-3">
                      Crea, elimina, habilita y deshabilita turnos.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 mt-3 mt-md-0  px-3">
                <div
                  className="card"
                  style={{ cursor: "pointer" }}
                  onClick={handleAsignarTurnosClick}
                >
                  <div className="card-body section-typography">
                    <h6 className="">
                      Administrar <span>equipos</span>
                    </h6>
                    <p className="card-text mt-3">
                      Crea, elimina y edita la disponibilidad los equipos.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-md-6  px-3">
                <div
                  className="card"
                  style={{ cursor: "pointer" }}
                  onClick={handleNuevaFecha}
                >
                  <div className="card-body section-typography">
                    <h6 className="">
                      Crear <span>fecha</span>
                    </h6>
                    <p className="card-text mt-3">
                      Elige los equipos que querés que jueguen y crea la fecha
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-6 mt-3 mt-md-0 px-3">
                <div
                  className="card"
                  style={{ cursor: "pointer" }}
                  onClick={mostrarShowModalCargaMasiva}
                >
                  <div className="card-body section-typography">
                    <h6 className="">
                      Carga <span>masiva</span>
                    </h6>
                    <p className="card-text mt-3">
                      Descarga una planilla modelo y carga turnos fácilmente.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm p-0 g-0">
              {error && <div className="alert alert-danger">{error}</div>}
              {fechas.length === 0 ? (
                // <img
                //   src="ruta_de_tu_imagen/no_hay_fechas_disponibles.jpg" // Reemplaza esto con la ruta de tu imagen
                //   // alt="No hay fechas disponibles"
                //   style={{
                //     maxWidth: "100%",
                //     maxHeight: "100%",
                //     display: "block",
                //     margin: "auto",
                //   }}
                // />
                <div className="section-typography mt-5">
                  <p>Aquí se mostrarán las fechas, cuando las crees</p>
                </div>
              ) : (
                <div className="col-sm g-0" style={{ paddingBottom: "20px" }}>
                  <div className="section-typography mt-5">
                    <h6>
                      Fechas <span>creadas</span>
                    </h6>
                  </div>
                  <div className="row g-0 px-4">
                    {fechas.map((fecha, index) => (
                      <div key={fecha.id} className="col-sm-4 px-3 py-2">
                        <div className="card h-100">
                          <div
                            onClick={() =>
                              navigate(`/torneo/${idTorneo}/fecha/${fecha.id}`)
                            }
                            style={{ cursor: "pointer" }}
                            className="card-body d-flex align-items-center"
                          >
                            <div className="col-sm-10">
                              <h5 className="card-title mb-0">
                                Fecha {fecha.descFecha}
                              </h5>
                            </div>
                            <div className="col-sm-2">
                              <div className="d-flex justify-content-end">
                                <i
                                  className="fas fa-trash me-2 text-danger"
                                  onClick={(e) => {
                                    e.stopPropagation(); // Detener la propagación del evento
                                    handleDeleteMatchweek(fecha.id);
                                  }}
                                  data-toggle="tooltip"
                                  data-placement="top"
                                  title="Eliminar fecha"
                                  style={{ cursor: "pointer" }}
                                ></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>

          <Modal
            show={showModalConfirmation}
            onHide={() => setShowModalConfirmation(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>Advertencia</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              ¿Estás seguro que querés eliminar esta fecha junto con todos los
              partidos que contiene?
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowModalConfirmation(false)}
              >
                Cancelar
              </Button>
              <Button
                variant="danger"
                onClick={() => confirmarEliminacion(fechaAEliminar)}
              >
                Eliminar
              </Button>
            </Modal.Footer>
          </Modal>
          <ModalCargaMasiva
            showModalCargaMasiva={showModalCargaMasiva}
            quitar={quitarShowModalCargaMasiva}
          />
        </div>
      )}
    </div>
  );
};

export default Torneo;
